import { render, staticRenderFns } from "./speaker-invitation-list.vue?vue&type=template&id=bbe4536a"
import script from "./speaker-invitation-list.vue?vue&type=script&lang=js"
export * from "./speaker-invitation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports